export default "__VITE_ASSET__0Wn8a67U__"